import { render, staticRenderFns } from "./gift-rule-form.vue?vue&type=template&id=7cb19c5e"
import script from "./gift-rule-form.vue?vue&type=script&lang=js"
export * from "./gift-rule-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports